"use strict";
const _ = require('lodash');
const mapEntries = [
    { vectorMapCode: 'SE-O', name: 'Västra Götaland', zipStart: 51, zipEnd: 54 },
    { vectorMapCode: 'SE-N', name: 'Halland', zipStart: 31, zipEnd: 31 },
    { vectorMapCode: 'SE-N', name: 'Halland', zipStart: 42, zipEnd: 47 },
    { vectorMapCode: 'SE-M', name: 'Skåne', zipStart: 20, zipEnd: 29 },
    { vectorMapCode: 'SE-K', name: 'Blekinge', zipStart: 37, zipEnd: 37 },
    { vectorMapCode: 'SE-I', name: 'Gotland', zipStart: 62, zipEnd: 62 },
    { vectorMapCode: 'SE-H', name: 'Kalmar', zipStart: 38, zipEnd: 39 },
    { vectorMapCode: 'SE-G', name: 'Kronoberg', zipStart: 34, zipEnd: 36 },
    { vectorMapCode: 'SE-F', name: 'Jönköping', zipStart: 33, zipEnd: 33 },
    { vectorMapCode: 'SE-F', name: 'Jönköping', zipStart: 55, zipEnd: 57 },
    { vectorMapCode: 'SE-E', name: 'Östergötland', zipStart: 59, zipEnd: 61 },
    { vectorMapCode: 'SE-D', name: 'Södermanland', zipStart: 64, zipEnd: 64 },
    { vectorMapCode: 'SE-C', name: 'Uppsala', zipStart: 74, zipEnd: 75 },
    { vectorMapCode: 'SE-C', name: 'Uppsala', zipStart: 81, zipEnd: 81 },
    { vectorMapCode: 'SE-Z', name: 'Jämtland', zipStart: 83, zipEnd: 84 },
    { vectorMapCode: 'SE-Y', name: 'Västernorrland', zipStart: 86, zipEnd: 89 },
    { vectorMapCode: 'SE-X', name: 'Gävleborg', zipStart: 80, zipEnd: 85 },
    { vectorMapCode: 'SE-W', name: 'Dalarna', zipStart: 77, zipEnd: 79 },
    { vectorMapCode: 'SE-BD', name: 'Norrbotten', zipStart: 90, zipEnd: 98 },
    { vectorMapCode: 'SE-T', name: 'Orebro', zipStart: 69, zipEnd: 71 },
    { vectorMapCode: 'SE-S', name: 'Värmland', zipStart: 65, zipEnd: 68 },
    { vectorMapCode: 'SE-U', name: 'Västmanland', zipStart: 73, zipEnd: 73 },
    { vectorMapCode: 'SE-AC', name: 'Västerbotten', zipStart: 91, zipEnd: 93 },
    { vectorMapCode: 'SE-AB', name: 'Stockholm', zipStart: 10, zipEnd: 19 },
    { vectorMapCode: 'SE-AB', name: 'Stockholm', zipStart: 76, zipEnd: 76 },
];
function zipToMapMap(zip) {
    if (!zip)
        return null;
    const zipStart = _.parseInt(zip.substr(0, 2));
    const mapEntry = _.first(mapEntries.filter(p => zipStart >= p.zipStart && zipStart <= p.zipEnd));
    return _.get(mapEntry, 'vectorMapCode');
}
const emptyMap = {
    'SE-O': 0,
    'SE-N': 0,
    'SE-M': 0,
    'SE-K': 0,
    'SE-I': 0,
    'SE-H': 0,
    'SE-G': 0,
    'SE-F': 0,
    'SE-E': 0,
    'SE-D': 0,
    'SE-C': 0,
    'SE-Z': 0,
    'SE-Y': 0,
    'SE-X': 0,
    'SE-W': 0,
    'SE-BD': 0,
    'SE-T': 0,
    'SE-S': 0,
    'SE-U': 0,
    'SE-AC': 0,
    'SE-AB': 0,
};
module.exports = { emptyMap, zipToMapMap };
